import {
  type IconProps,
  PhotoSquareOutlineIcon as ImageVariableIcon,
  TextOutlineIcon as TextVariableIcon,
} from '@carboncopyco/icons';
import type { IVariable } from '@carboncopyco/types';
import { RuleIcon, type RuleIconProps } from '../RuleIcon';

export interface VariableIconProps extends Pick<RuleIconProps, 'size'> {
  type: IVariable['type'];
}

const iconTypes: Record<IVariable['type'], (props: IconProps) => JSX.Element> =
  {
    text: TextVariableIcon,
    image: ImageVariableIcon,
  };

const iconSizes: Record<Required<VariableIconProps>['size'], number> = {
  sm: 12,
  md: 24,
};

export const VariableIcon = ({ size = 'md', type }: VariableIconProps) => {
  const Icon = iconTypes[type];
  return (
    <RuleIcon size={size}>{Icon && <Icon size={iconSizes[size]} />}</RuleIcon>
  );
};
